<script lang="ts">
  import { GithubIcon, Linkedin, TwitterIcon } from "lucide-svelte";

  import logotype from "$lib/assets/logotype.svg";
</script>

<!-- This margin element is separate from the element below, and it disables pointer interactions. -->
<div class="mt-24 pointer-events-none"></div>

<footer class="mt-auto">
  <div
    class="px-4 py-6 border-t border-c-gray-10 flex flex-col gap-y-[27px] lg:flex-row lg:items-center"
  >
    <div class="flex items-center gap-x-3">
      <img src={logotype} alt="Modal logo" class="h-[18px]" />
      <span class="whitespace-nowrap text-c-gray-40 text-xs">© 2025</span>
    </div>
    <div
      class="grid gap-y-3 gap-x-6 grid-cols-2 sm:grid-cols-4 lg:flex lg:ml-auto lg:mr-14"
    >
      <a class="link" href="/company">About</a>
      <a
        class="link"
        href="https://status.modal.com/"
        target="_blank"
        rel="noopener noreferrer">Status</a
      >
      <a class="link" href="/docs/reference/changelog">Changelog</a>
      <a class="link" href="/docs/guide">Documentation</a>
      <a class="link" href="/slack" target="_blank" rel="noopener noreferrer"
        >Slack Community</a
      >
      <a class="link" href="/pricing">Pricing</a>
      <a class="link" href="/docs/examples">Examples</a>
    </div>
    <div class="flex space-x-4">
      <a
        href="https://www.linkedin.com/company/modal-labs/"
        target="_blank"
        rel="noreferrer"
        class="social-link"
      >
        <Linkedin size={20} class="stroke-none fill-current" />
      </a>
      <a
        href="https://twitter.com/modal_labs"
        target="_blank"
        rel="noreferrer"
        class="social-link"
      >
        <TwitterIcon size={20} class="stroke-none fill-current" />
      </a>
      <a
        href="https://github.com/modal-labs"
        target="_blank"
        rel="noreferrer"
        class="social-link"
      >
        <GithubIcon size={20} class="stroke-none fill-current" />
      </a>
    </div>
    <div></div>
  </div>
</footer>

<style lang="postcss">
  .link {
    @apply text-sm text-c-gray-60 hover:text-white transition-colors;
  }

  .social-link {
    @apply text-c-gray-50 hover:text-white transition-colors;
  }
</style>
